import React from 'react';
import { useSelector } from 'react-redux';
import '@css/Spinner.css';
import logo from "@images/yuldo_logo_white.png";

const GlobalSpinner = () => {
    const loading = useSelector(state => state.loading);

    if (!loading) return null;

    return (
        <div className="global-spinner-overlay">
            <div className="spinner-container">
                <div className="modern-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-logo">
                        <img src={logo} alt="Yuldo" className="spinner-logo-image" />
                    </div>
                </div>
                <div className="spinner-text">로딩 중...</div>
            </div>
        </div>
    );
};

export default GlobalSpinner;
